import {ref} from 'vue';
import {defineStore} from 'pinia';
import {readonlyState} from '@malt/utils';
import type {IndustryExpertiseResource} from '@api';
import {Configuration, PublicSkillsAndExpertisesApi} from '@api';

export const useIndustryExpertiseStore = defineStore('industry-expertise', () => {
    // Refs
    const industryExpertises = ref<IndustryExpertiseResource[]>([]);

    // API
    const _api = new PublicSkillsAndExpertisesApi(new Configuration({basePath: ''}));
    const _hasBeenLoaded = ref(false);

    async function loadIndustryExpertises(): Promise<void> {
        if (!_hasBeenLoaded.value) {
            industryExpertises.value = (await _api.listAllExpertise()).sort((a, b) => a.label.localeCompare(b.label));
            _hasBeenLoaded.value = true;
        }
    }

    return {
        // RO A-Z
        industryExpertises: readonlyState(industryExpertises),

        // Functions A-Z
        loadIndustryExpertises,
    };
});
